/* Wraps Convex billing queries for convenient subscription state access. */

import { useQuery, useAction } from "convex/react";
import { useState } from "react";
import { api } from "../../convex/_generated/api";
import { posthog } from "@/lib/posthog";
import { Events } from "@/lib/posthogEvents";

export function useSubscription() {
  const subscription = useQuery(api.billing.getSubscription);
  const isLoading = subscription === undefined;
  const isActive = subscription?.isActive ?? false;
  const isPro = isActive;
  const isFree = !isActive;
  const isPastDue = subscription?.isPastDue ?? false;
  const isCanceling = subscription?.isCanceled ?? false;
  const currentPeriodEnd = subscription?.currentPeriodEnd;

  return {
    subscription,
    isLoading,
    isActive,
    isPro,
    isFree,
    isPastDue,
    isCanceling,
    currentPeriodEnd,
  };
}

export function useStripeCheckout() {
  const createCheckout = useAction(api.billing.createCheckoutSession);
  const createPortal = useAction(api.billing.createPortalSession);
  const [isRedirecting, setIsRedirecting] = useState(false);

  async function redirectToCheckout(priceId: string) {
    setIsRedirecting(true);
    posthog.capture(Events.CHECKOUT_STARTED, { priceId });
    try {
      const { url } = await createCheckout({
        priceId,
        successUrl: `${window.location.origin}/settings?success=true`,
        cancelUrl: `${window.location.origin}/pricing?canceled=true`,
      });
      window.location.href = url;
    } catch (error) {
      setIsRedirecting(false);
      throw error;
    }
  }

  async function redirectToPortal() {
    setIsRedirecting(true);
    posthog.capture(Events.SUBSCRIPTION_PORTAL_OPENED);
    try {
      const { url } = await createPortal({
        returnUrl: `${window.location.origin}/settings`,
      });
      window.location.href = url;
    } catch (error) {
      setIsRedirecting(false);
      throw error;
    }
  }

  return { redirectToCheckout, redirectToPortal, isRedirecting };
}
